import React, { useEffect, useState } from "react";

const Message = ({ type, children }) => {
  const [color, setColor] = useState("");
  useEffect(() => {
    switch (type) {
      case "error":
        setColor("bg-red-300");
        break;
      case "warning":
        setColor("bg-orange-600");
        break;
      case "success":
        setColor("bg-green-500");
        break;
      default:
        setColor("bg-blue-400");
        break;
    }
  }, [type]);

  return (
    <p
      className={`${color} text-white font-semibold py-2 px-3 text-sm align-middle rounded-md`}
    >
      {children}
    </p>
  );
};

export default Message;
